export function stringifyObjectToCSS(styles: object) {
  const vars = Object.entries(styles)
    .filter(([, value]) => value !== "")
    .map(([property, value]) => `${property}:${value}`)
    .join(";");

  return vars.length > 0 ? vars + ";" : "";
}
